import axios from 'axios'

export const HTTP = axios.create({
  // baseURL: process.env.NODE_ENV === 'production' ? 'http://quiz-api.matapa.nu/' : 'http://localhost:8001',
  // baseURL: 'https://httpstat.us/',
  // baseURL: '',
  baseURL: process.env.NODE_ENV === 'production' ? '' : 'https://httpstat.us/',
  timeout: 30000
})



// WEBPACK FOOTER //
// ./src/helpers/http-common.js